import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Button from '../../constant/Button';
import { Roles } from '../../constant/JSON/Roles.js';
import { SetDate } from '../../common/SetDate';

import { NumberFormats } from '../../common/SetNumberFormat';
import { GetStatusColor } from '../../common/GetStatusColor';

import { Family, Fonts, Colors, Icons,  } from '../../themes';

import CONFIG from '../../config';
import DialogAction from '../../componets/DialogAction'
import DialogPanel from '../../componets/DialogPanel.jsx';

import SearchPanel from '../../componets/SearchPanel.jsx';

import * as AccountingActions from '../../actions/Actions_Accounting.js';
import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../common/SetTime.js';

import WithDrawHistoryPanel from './WithDrawHistoryPanel';
import TableComponent from '../../componets/TableComponent.jsx';

const { CancelIcon,VisibilityIcon,SendIcon } = Icons;

let WithDrawHistory = [];
let waitingTime = true;

const fildeLists = [
    { label: 'ID', name: 'transferId', isOrder: true, },
    { label: 'DATE', name: 'createDate', isOrder: true, },
    { label: 'WITHDRAW', name: 'amount', isOrder: true, },
    { label: 'STATUS', name: 'transferStatus', isOrder: false, }];

/* Desktop */
const _callStyle = { textAlign: 'center', padding: '5px', border: `${'1px solid' + Colors.white}` };
const _callCustomStyle = { ..._callStyle, backgroundColor: Colors.themeDark, color: Colors.white, }
const _callName = { ..._callStyle, textAlign: 'left', paddingRight: '15px', maxWidth: 280 };

/* Mobile */
const _callStyleMobile = { ..._callStyle, padding: 2, fontSize: 11, width: 50, };
const _callNameMobile = { ..._callStyleMobile, textAlign: 'left', maxWidth: 80, };

const init_withdraw = {
    status: '',
    remark: ''
}


class AccountingHistoryListPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isWithdraw: false, isView: false,
            isLoading: false, msgError: undefined, dialogType: undefined,
            orderBy: 'desc', sortFilde: undefined, searchActive: false
        }

        const { userInfo, Role } = this.props;
        switch (Role) {
            case Roles.Supplier: {
                this.props.getAPIAccoutingHistoryList({ key: 'updateDate', orderBy: 'desc', num_limit: 10, where: { "userAssigneeId": userInfo.supplierId } });
            } break;
            case Roles.Seller: {
                this.props.getAPIAccoutingHistoryList({ key: 'updateDate', orderBy: 'desc', num_limit: 10, where: { "userAssigneeId": userInfo.sellerId } });
            } break;
        }

    }

    componentWillReceiveProps(nextProps) {
        // console.log('nextProps', nextProps);
        const { AccountingManager } = nextProps;

        if (!!AccountingManager) {

            const { actions, data } = AccountingManager.ACCOUNTING_REDUCER

            switch (actions) {
                case AccountingActions.GET_ACCOUNTING_HISTORY_LIST_SUCCESS:
                    {
                        AccountingManager.ACCOUNTING_REDUCER.actions = AccountingActions.WATING_STATE;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case AccountingActions.GET_ACCOUNTING_HISTORY_LIST_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }


    render() {

        const { classes, isWithdraw, withDrawHistoryList, CreatePanel, EditInfo, userInfo, onClickHandle, isEmployee, Header, SearchType, isActive, isMobile } = this.props;
        const { DisplaySupplierInfo } = this;

        WithDrawHistory = withDrawHistoryList.datas || []
        const _isWithDraw = (WithDrawHistory.length > 0);
        const { isLoading, msgError, dialogType, searchActive, orderBy, isWithDrawPanel, withdrawInfo, isView, } = this.state;
        // console.log('withdrawInfo : ', withdrawInfo)
        // const _isEmployee = (Boolean(isEmployee));


        return (
            <React.Fragment>
                {(isLoading) && <DialogPanel Active={isLoading} MSG={msgError} Type={dialogType} OnClose={() => { this.onCloseDialog() }} />}
                {(isWithDrawPanel) && <DialogAction Active={isWithDrawPanel} OnClose={this.onClosePanel} AcrionCom={this.WithDrawPanel(isView, withdrawInfo)} />}

                <TableComponent isCreate icon={<SendIcon />} tooltip={'Send'}
                    Header={Header}
                    orderBy={orderBy}
                    isActive={_isWithDraw}
                    FildeLists={fildeLists}
                    HandleRequestSort={this.handleRequestSort}
                    onClickCreate={() => this.onClickCreate()}
                    ListCount={withDrawHistoryList}
                    onNextPage={this.onNextPage}
                    onChangeLimit={this.onChangeLimit}
                    GetBookingRows={GetBookingRows(classes, WithDrawHistory, this.DisplayPanel, isMobile)} />

            </React.Fragment >
        );
    }

    onClickCreate = () => {
        const { userInfo } = this.props;
        console.log('onClickCreate', userInfo);
        this.setState({ isWithDrawPanel: true, withdrawInfo: userInfo })
    }

    WithDrawPanel = (isView, withdrawInfo) => {
        return <WithDrawHistoryPanel isView={isView} withdrawInfo={withdrawInfo} onClosePanel={this.onClosePanel} userInfo={this.props.userInfo} Role={this.props.Role} />
    };

    DisplayPanel = (_action, _info) => {
        switch (_action) {
            case 'view': {
                this.setState({ isWithDrawPanel: true, isView: true, withdrawInfo: _info })
            } break;
        }
    };

    handleRequestSort = (sortFilde) => {

        const { orderBy, field } = sortFilde;
        const _fildeName = field.name;

        if (WithDrawHistory) {
            WithDrawHistory = (orderBy === 'desc')
                ? WithDrawHistory.sort((a, b) => (b[_fildeName] < a[_fildeName] ? -1 : 1))
                : WithDrawHistory.sort((a, b) => (a[_fildeName] < b[_fildeName] ? -1 : 1));

            this.setState({ orderBy: ((orderBy === 'asc') ? 'desc' : 'asc'), sortFilde: _fildeName });
        }
    };
    onNextPage = (_pageNumber, _limit) => {
        this.setState({ isLoading: true });

        const { userInfo, Role } = this.props;
        switch (Role) {
            case Roles.Supplier:
                {
                    this.props.getAPIAccoutingHistoryList({ page: _pageNumber, num_limit: (_limit || 10), key: 'updateDate', orderBy: 'desc', where: { "userAssigneeId": userInfo.supplierId } });
                } break;
            case Roles.Seller:
                {
                    this.props.getAPIAccoutingHistoryList({ page: _pageNumber, num_limit: (_limit || 10), key: 'updateDate', orderBy: 'desc', where: { "userAssigneeId": userInfo.sellerId } });
                } break;
        }
    }

    onChangeLimit = (_limitRows) => {
        this.setState({ isLoading: true });
        const { userInfo, Role } = this.props;
        switch (Role) {
            case Roles.Supplier:
                {
                    this.props.getAPIAccoutingHistoryList({ page: 0, num_limit: _limitRows, key: 'updateDate', orderBy: 'desc', where: { "userAssigneeId": userInfo.supplierId } });
                } break;
            case Roles.Seller:
                {
                    this.props.getAPIAccoutingHistoryList({ page: 0, num_limit: _limitRows, key: 'updateDate', orderBy: 'desc', where: { "userAssigneeId": userInfo.sellerId } });
                } break;
        }
    }


    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));
    onClosePanel = () => (this.setState({ isWithDrawPanel: false, isView: false }));

}

function GetBookingRows(classes, WithDrawHistory, DisplayPanel, isMobile) {

    return WithDrawHistory.map(_info => {

        const { transferId, approved, transferStatus, amount, balance, createDate, id, link, oldBalance, userAssigneeId, userAssigneeName, userAssigneeType, userTransfererId, userTransfererName, userTransfererType } = _info;
        const isCallStyle = (isMobile) ? _callStyleMobile : _callStyle;
        const isCallNameStyle = (isMobile) ? _callNameMobile : _callName;

        return (
            <TableRow hover className={classes.row} style={{ cursor: 'pointer' }} key={transferId} onClick={() => { DisplayPanel('view', _info) }} >
                <TableCell style={isCallStyle}>{transferId || '-'}</TableCell>
                <TableCell style={isCallStyle} >{SetDate(createDate)}</TableCell>
                <TableCell style={GetStatusColor('Request', isCallStyle, transferStatus)} >{NumberFormats(amount || 0)}</TableCell>
                <TableCell style={GetStatusColor('Request', isCallStyle, transferStatus)} >{transferStatus || '-'}</TableCell>
            </TableRow>
        )
    });
}

const styles = theme => (
    {
        root: {
            width: '100%',
            // marginTop: theme.spacing.unit * 3,
            // overflowX: 'auto',
            // marginBottom: 10,
        },
        table: { minWidth: 1024, },
        tableMobile: { width: '100%' },
        row: {
            '&:nth-of-type(odd)': {
                backgroundColor: Colors.themeDark_Light,
            },
            '&:nth-of-type(odd):hover': {
                backgroundColor: Colors.themeDark_Item,
            },
        },
    });

AccountingHistoryListPanel.propTypes = { classes: PropTypes.object.isRequired, };

function mapStateToProps(state, ownProps) { return { ...state }; }

function mapDispatchToProps(dispatch) {
    return {
        // getAPISupplierList: (_keyword, _filter) => {
        //     InitWaitingTime();
        //     dispatch(SupplierActions.getSupplierList(_keyword, _filter));
        // },
        getAPIAccoutingHistoryList: (_filter) => {
            dispatch(AccountingActions.getAccoutingHistoryList(_filter));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AccountingHistoryListPanel));


